// ─── Référentiel d'ingrédients — BASE GLOBALE (partagée, lecture seule) ──
// Un seul document pour toute la suite (dictionnaire commun) : les comptes
// LISENT, personne n'écrit directement (cf. ingredientsPerso pour les ajouts/
// corrections personnels — y compris sur les RAYONS). Alimentée par script/
// admin.
//   ingredientsBase/global = {
//     items: [{id, nom, unite, categorie}],
//     rayons: [{id, label, emoji}],   // absent/vide → repli sur RAYONS par défaut
//     maj }
import { db } from '@mop/core';
import { doc, onSnapshot } from 'firebase/firestore';

// callback(items, rayons)
export function ecouterBase(callback, onErreur) {
  return onSnapshot(doc(db, 'ingredientsBase', 'global'),
    s => callback(s.exists() ? (s.data().items || []) : [], s.exists() ? (s.data().rayons || []) : []),
    (e) => { callback([], []); onErreur?.(e); });
}
